// client/src/pages/common/TermsOfService.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';

const TermsOfService = () => {
  const { t } = useTranslation('legal');

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-md p-6 sm:p-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('terms.title')}</h1>
          <p className="text-sm text-gray-500 mb-8">{t('terms.lastUpdated')}</p>

          <p className="text-gray-700 mb-6">{t('terms.intro')}</p>
          <p className="text-gray-700 mb-8">{t('terms.introAcceptance')}</p>

          {/* Section 1 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">1. {t('terms.definitions.title')}</h2>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
            <li><strong>{t('terms.definitions.platform')}:</strong> {t('terms.definitions.platformDesc')}</li>
            <li><strong>{t('terms.definitions.wholesaler')}:</strong> {t('terms.definitions.wholesalerDesc')}</li>
            <li><strong>{t('terms.definitions.customer')}:</strong> {t('terms.definitions.customerDesc')}</li>
            <li><strong>{t('terms.definitions.user')}:</strong> {t('terms.definitions.userDesc')}</li>
          </ul>

          {/* Section 2 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">2. {t('terms.nature.title')}</h2>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
            <li>{t('terms.nature.saas')}</li>
            <li>{t('terms.nature.noSales')}</li>
            <li>{t('terms.nature.directContract')}</li>
            <li>{t('terms.nature.noLiability')}</li>
          </ul>

          {/* Section 3 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">3. {t('terms.accounts.title')}</h2>
          <p className="text-gray-700 mb-6">{t('terms.accounts.body')}</p>

          {/* Section 4 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">4. {t('terms.privateCatalog.title')}</h2>
          <p className="text-gray-700 mb-6">{t('terms.privateCatalog.body')}</p>

          {/* Section 5 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">5. {t('terms.pricing.title')}</h2>
          <p className="text-gray-700 mb-6">{t('terms.pricing.body')}</p>

          {/* Section 6 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">6. {t('terms.liability.title')}</h2>
          <p className="text-gray-700 mb-6">{t('terms.liability.body')}</p>

          {/* Section 7 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">7. {t('terms.ip.title')}</h2>
          <p className="text-gray-700 mb-6">{t('terms.ip.body')}</p>

          {/* Section 8 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">8. {t('terms.law.title')}</h2>
          <p className="text-gray-700 mb-4">{t('terms.law.body')}</p>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-gray-600 text-sm">{t('terms.contact')}: <a href="mailto:charitakistheodoros@gmail.com" className="text-blue-600 hover:underline">charitakistheodoros@gmail.com</a></p>
          </div>

          <div className="mt-6">
            <Link to="/privacy" className="text-blue-600 hover:underline text-sm">{t('privacy.title')} &rarr;</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
